/*04294686103
Luis1234
*/
// export const API_URL = 'http://18.230.75.177:1415';
export const API_URL = 'https://api.konectasaude.com.br';
// export const API_URL = 'https://z3rx9jpa3x.us-east-1.awsapprunner.com';
const bearer =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTAsInRpcG8iOjEsImlhdCI6MTc2MTE1OTM2MX0.FrLa-MOsu2lXOM0U5TxLCL61jLnQo4zRIeleo-nOUfg';

export function LOGIN_POST(body) {
  return {
    url: API_URL + '/usuario/login',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  };
}

export function TOKEN_VALIDATE_GET(token) {
  return {
    url: API_URL + '/validatoken',
    options: {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function DOCS_GET(token) {
  return {
    url: API_URL + '/documento',
    options: {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function USER_LOGOUT(body, token) {
  return {
    url: API_URL + '/usuario/logout',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(body),
    },
  };
}

export function PASSWORD_LOST(body) {
  return {
    url: API_URL + '/recuperarsenha',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearer,
      },
      body: JSON.stringify(body),
    },
  };
}

export function PASSWORD_RESET(body, token) {
  return {
    url: API_URL + '/usuario/alterarsenhalink',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(body),
    },
  };
}
export function PASSWORD_CHANGE(body, token) {
  return {
    url: API_URL + '/usuario/senha',
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(body),
    },
  };
}
export function USER_GET(token) {
  return {
    url: API_URL + '/getemail/' + token,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  };
}

export function USER_GET_CPF(token) {
  return {
    url: API_URL + '/getcpf/' + token,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function GET_USER_INFO(token) {
  return {
    url: API_URL + '/usuario',
    options: {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function DOC_ACESSO_POST(body, token) {
  return {
    url: API_URL + '/doc_acesso',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(body),
    },
  };
}
